import React from "react";
import { Container, Box } from "@material-ui/core";
import CenterLayout from "./CenterLayout";

const BgWrap = (props) => {
  const { layout = 10, empty = false } = props;
  if (empty) {
    return <div>{props.children}</div>;
  }
  return (
    <Box bgcolor="primary.main" color="primary.contrastText" pt={2} pb={2}>
      <CenterLayout grid={layout}>
        <Container>{props.children}</Container>
      </CenterLayout>
    </Box>
  );
};

export default BgWrap;
